module.exports = __webpack_public_path__ + "static/media/cash.c15f7eb3.svg";